import React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  FindAllBanksQueryQuery,
  // Bank
} from "../../schemaTypes";

export const findAllBanksQuery = gql`
  query FindAllBanksQuery {
    findAllBanks {
      id
      bank
      bankCode
      pictureUrl
      createdAt
      updatedAt
    }
  }
`;

export const newBankSubscription = gql`
  subscription NewBankSubscription {
    newBank {
      id
      bank
      bankCode
      pictureUrl
      createdAt
      updatedAt
    }
  }
`;

export function useFindAllBanks() {
  const { data, loading, subscribeToMore } = useQuery<FindAllBanksQueryQuery>(findAllBanksQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newBankSubscription,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findAllBanks: [
            ...prev.findAllBanks,
            (subscriptionData.data as any).newBank
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    banks: data?.findAllBanks ?? [],
    loading
  };
}